import { render, staticRenderFns } from "./ConditionalText.vue?vue&type=template&id=bc46a5be"
import script from "./ConditionalText.vue?vue&type=script&lang=js"
export * from "./ConditionalText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports